var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images.length)?_c('div',{ref:"gallery",staticClass:"grid grid-cols-2 md:grid-cols-4 gap-5"},_vm._l((_vm.images),function(image){return _c('div',{key:image.id},[_c('a',{staticClass:"gallery-item",attrs:{"href":image.largeFileUrl}},[_c('img',{staticClass:"rounded-md",attrs:{"src":image.smallFileUrl,"alt":image.caption}})])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }